import React from "react";
import { Helmet } from "react-helmet-async";
import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/hero3.png";
import "./privacy-policy.css";
import { color } from "framer-motion";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Servizy</title>
        <meta
          name="description"
          content="Read the Servizy privacy policy for doorstep repair service bookings, customer information, and data protection."
        />
        <link rel="canonical" href="https://servizy.in/privacy-policy" />
      </Helmet>

      <InnerBanner title="Privacy Policy" bgImage={serviceBg} />
      <main className="privacy-wrapper">
        <section className="privacy-container">
          <h1 className="privacy-title" style={{"color":"red"}}>Privacy Policy </h1>
          <p>
            <strong>Effective Date:</strong> 26 March 2026
          </p>
          <p>
            Customer Support 24*7 respects your privacy and ensures your personal data is
            handled securely.
          </p>

          <h2>1. Information We Collect</h2>
          <ul>
            <li>Name, phone number, and address for doorstep service.</li>
            <li>
         Device details (model, issue, serial/IMEI if required)

            </li>
          </ul>

          <h2>2. How We Use Information</h2>
          <ul>
            <li>To schedule and complete repair services.</li>
            <li>To communicate service updates and support.</li>
            <li>To maintain service records.</li>
          </ul>

          <h2>3. Data Protection</h2>
          <p>
            Your data is kept confidential and is not sold or shared with third
            parties except as required by law.
          </p>

          <h2>4. Device Data Disclaimer</h2>
          <p>Customers are advised to back up their data before service.</p>
          <p>Customer Support 24*7 is not responsible for data loss during repair.</p>

          <h2>5. Third-Party Links</h2>
          <p>
            Customer Support 24*7 is not responsible for external websites linked from our
            platform.
          </p>

          <h2>6. Updates to Policy</h2>
          <p>
            Policies may be updated periodically. Changes will be reflected with
            a revised date.
          </p>

          <h2>7. Contact Information</h2>
          <div className="cta-box">
            <p>
              <strong>For queries or concerns:</strong>
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:info@customersupport24x7.in">info@customersupport24x7.in</a>
            </p>
            <p>
              <strong><a href="tel:8050731754">Phone:8050731754</a></strong> 
            </p>
          
          </div>
        </section>
      </main>
    </>
  );
};

export default PrivacyPolicy;
